import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import SEOHead from './SEOHead';
import { LEGAL_LINKS } from '../data/legalLinks';

const LegalDocumentLayout = ({ title, description, canonical, sections, children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead title={title} description={description} canonical={canonical} />
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <nav className="text-sm text-muted-foreground mb-6 flex flex-wrap gap-x-4 gap-y-1">
            <Link to={LEGAL_LINKS.privacy} className="hover:text-accent">
              Политика ПДн
            </Link>
            <Link to={LEGAL_LINKS.cookies} className="hover:text-accent">
              Cookies и аналитика
            </Link>
          </nav>
          <h1 className="text-3xl font-bold mb-8">{title}</h1>
          {sections?.map((section) => (
            <section key={section.id} id={section.id} className="mb-10 scroll-mt-28">
              <h2 className="text-xl font-semibold mb-3">{section.title}</h2>
              {section.paragraphs?.map((p, i) => (
                <p key={i} className="text-muted-foreground leading-relaxed mb-3">
                  {p}
                </p>
              ))}
              {section.list && (
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  {section.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalDocumentLayout;
